export default __webpack_public_path__ + "static/media/logo-white.27c9ae9a.png";